export const SITE = {
  name: "BeGreat Basketball Training",
  shortName: "BeGreat",
  location: "Mankato, MN",
  phone: "507-766-2692",
  phoneHref: "tel:5077662692",
  email: "BeGreatSports@outlook.com",
  instagram: "https://www.instagram.com/begreatbasketballtraining/",
  instagramHandle: "@begreatbasketballtraining",
  facebook: "https://www.facebook.com/profile.php?id=61566019645079",
  facebookHandle: "BeGreat Basketball Training",
  tiktok: "https://www.tiktok.com/@begreatbasketball1",
  tiktokHandle: "@begreatbasketball1",
  tagline: "Be Uncommon.",
  pillar: "#BeGreat",
  promise: "Game Skills = Game Results",
  description:
    "Elite small-group basketball training in Mankato, Minnesota. From 3rd grade through the professional level — Game Skills that translate into Game Results.",
  clothingUrl: "https://shop.game-one.com/minnesota/mankato/be-great-sports-training",
  // Brand assets
  logo: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/jvzlsq9z_BeGreat%20Logo.png",
  logoDark: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ds8auc48_IMG_7804.PNG",
  // Reviews
  googleReviewUrl: "https://g.page/r/CWzVFt6XFoYeEBM/review",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/clothing", label: "Clothing", id: "clothing", external: true },
  { to: "/school-camps", label: "School Camps", id: "school-camps" },
  { to: "/fall-league", label: "Fall League", id: "fall-league" },
  { to: "/girls-camp", label: "Girls Camp", id: "girls-camp" },
  { to: "/trainers", label: "Trainers", id: "trainers" },
  { to: "/testimonials", label: "Testimonials", id: "testimonials" },
];

export const STATS = [
  { value: "Proven", label: "Development" },
  { value: "3rd → Pro", label: "Grade to Pro Level" },
  { value: "Boys & Girls", label: "All Athletes Welcome" },
];

// =========================================================================
// VIDEO REELS
// =========================================================================
export const VIDEO_REELS = [
  { id: "r1", title: "Be Great · 4/18", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/0uzglkwy_BegrEAT%20reel%204-18.mp4" },
  { id: "r2", title: "Top 3 WBB Players", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/p06qiiwb_BegrEAT%20x%20top%203%20wbb%20players.mp4" },
  { id: "r3", title: "Isaac · Goated Speech", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/oyhx1df4_BeGreat%20Isaac%20Goated%20Speech.mp4" },
  { id: "r4", title: "3/16 · Be Great", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/umql7u79_3-16%20Be%20Great.mp4" },
  { id: "r5", title: "10/12 · BegrEAT", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/cn59yx95_10-12%20BegrEAT.mp4" },
  { id: "r6", title: "11/3 · BegrEAT", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/3f998rp9_11-3%20BegrEAT.mp4" },
];

// =========================================================================
// TRAINERS
// =========================================================================
export const DIRECTOR = {
  id: "isaac-fink",
  name: "Isaac Fink",
  role: "Director / Trainer",
  image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/svic6mlh_DSC01454.jpg",
  images: [
    "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/svic6mlh_DSC01454.jpg",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/jjonpug5_Fink%20new.webp",
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/vqq63dh3_Me%20and%20Hennen.webp",
    "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/27m5sgkl_IMG_6433.JPG.png",
    "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ajmx2iew_IMG_7731.JPG.png",
    "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/1pj53woe_IMG_7729.JPG.png",
    "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/6anqoo0m_IMG_6390.png",
  ],
  bio: "Isaac is a seasoned basketball trainer and former standout player from Springfield High School, where he scored 3,382 career points — 7th all-time in MN Boys Basketball history. He continued his playing career at Augustana University (NSIC), finishing with 1,828 points (6th all-time in school history). His senior season he averaged 20.6 PPG, 7 RPG, and 2.2 APG — earning NABC All-Region, D2CCA All-Region, First Team All-NSIC (3× recipient), NSIC Senior of the Year, and a National Player of the Week honor.",
  bioExtended:
    "With over 10 years of experience running camps and training sessions — and more than 1,500 athletes developed — Isaac is passionate about building players at every level through high-energy, skill-focused instruction. He holds a Master's of Education (M.Ed.) and served as an Assistant Coach at Minnesota State University from 2024–2026. Isaac's dad, Bob, founded Be A Great Teacher in 2001 — sparking the lifelong passion for youth development that fuels BeGreat today.",
  stats: [
    { value: "3,382", label: "HS Career Points · 7th All-Time MN" },
    { value: "1,828", label: "College Points · 6th All-Time Augustana" },
    { value: "M.Ed.", label: "Master's of Education" },
    { value: "1,500+", label: "Athletes Trained" },
  ],
  accolades: [
    "NABC All-Region Team",
    "D2CCA All-Region Team",
    "First Team All-NSIC (3×)",
    "NSIC Senior of the Year",
    "National Player of the Week",
    "MSU Assistant Coach (2024–2026)",
  ],
};

export const TRAINERS = [
  DIRECTOR,
  {
    id: "jack-thompson",
    name: "Jack Thompson",
    role: "Trainer",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/72wksurm_IMG_2579.jpg",
    bio: "Jack joins the BeGreat team with an impressive coaching and player-development background. Currently an Assistant Coach at Minnesota State University after two seasons as an Assistant at MSU-Moorhead, Jack helped develop four first-time All-NSIC players and led his program to an NSIC Tournament Championship and a Sweet 16 appearance. He has also worked as a skill trainer for Sanford Sports — leading individual and small-group workouts for youth through pro athletes — and served as Head Coach of a 16U AAU team. Jack's experience, energy, and commitment to player growth make him a valuable addition to BeGreat.",
  },
  {
    id: "malik-willingham",
    name: "Malik Willingham",
    role: "Trainer",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ybxs7tpd_IMG_2577.jpg",
    bio: "Malik is a professional basketball player from Waseca, MN who played his college ball at Minnesota State University, where he won a National Championship as a key piece of MSU's first title. First Team All-American, NSIC and Central Region Player of the Year, NSIC Tournament MVP, and NCAA Elite Eight Most Outstanding Player. Top 3 in scoring at MSU (1,729 points), 2nd in three-pointers made, top 5 in assists — and the all-time leading scorer at Waseca. With tons of experience and a real joy for the game, Malik strives to be grEAT and turn the next generation into stars.",
  },
  {
    id: "molly-lenz",
    name: "Molly Lenz",
    role: "Trainer",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/if08v2sy_Molly.webp",
    bio: "We are super excited to announce that Molly Lenz is joining the BeGreat team. Molly's training background lines up directly with BeGreat's development philosophy: detail-driven skill development and coaching players through real in-game scenarios. We're also excited to strengthen the mental side of our system through her background and future career in Sport Psychology — building players' confidence through teaching is a huge part of our curriculum. Originally from Victoria, MN, Molly played at Eden Prairie High School before starting her college career at Illinois State and transferring to NDSU, where she started every game, shot 40% from three as a junior, won a Summit League Regular Season Championship, and earned Summit League All-Newcomer Team honors as a sophomore. In high school she was a 2x Section Champion, 2x All-State selection, 1,000-point scorer, and All-State Tournament Team member after a 3rd-place state finish her senior year. She is now pursuing a graduate degree in Sport Psychology and is passionate about combining the physical and mental sides of the game.",
  },
  {
    id: "joich-gong",
    name: "Joich Gong",
    role: "Trainer",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/3qp0ee38_IMG_2578.jpg",
    bio: "Joich Gong is a basketball coach and former player from Mankato, MN — known for his focus on player development and high-level skills training. After playing at Mankato East, Kirkwood Community College, and Bethany Lutheran, Joich has played a major role in developing the players at Mankato East and now serves as an Assistant Basketball Coach at Ellsworth Community College in Iowa, helping them reach the NCAA National Championship game in his first year on staff.",
  },
  {
    id: "karson-arrenholz",
    name: "Karson Arrenholz",
    role: "Trainer",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/u4gkiwi5_IMG_2576.jpg",
    bio: "Karson is entering his 7th season as an Assistant Basketball Coach at Minnesota State University. During his time at MSU he has coached 7 NSIC All-Conference players, 2 Newcomer of the Year recipients, 1 Player of the Year, and 1 All-American — compiling a 115–58 career record including a National Championship. A proven winner known for elite recruiting and player development, Karson connects with players from all over the world. The development he's done at the next level guides every BeGreat athlete to understand what it takes to succeed beyond high school.",
  },
  {
    id: "rj-wieseler",
    name: "RJ Wieseler",
    role: "Content Creator",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/104c0kf4_IMG_2581.jpg",
    bio: "Originally from Austin, MN, RJ also works with Minnesota State athletics — bringing high-level experience and a deep understanding of sports culture. His work captures the intensity of training, the emotion of competition, and the moments that define a team, helping bring BeGreat athletes' stories to life through powerful photo and video content.",
  },
];

// =========================================================================
// TESTIMONIALS — Real BeGreat athletes
// =========================================================================
export const TESTIMONIALS = [
  {
    id: "bj-omot",
    name: "BJ Omot",
    school: "California State University",
    accolade: "Power 5 Commit",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/uxhx7d9d_IMG_2587.jpg",
    quote: "BeGreat training improved my game through consistent workouts. Joich, Karson, and Isaac helped polish and expand my game for the Power 5 level!",
  },
  {
    id: "livi-tucker-downs",
    name: "Livi Tucker Downs",
    school: "University of South Dakota",
    accolade: "#10 Ranked 2026 Class",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/yuxzfryb_IMG_2588.jpg",
    quote: "BeGreat Basketball offers a unique training experience that sharpens both your skills and basketball IQ. The competitive, supportive environment challenges you to reach your full potential on and off the court. I feel blessed to have found this training that has me excited for the next workout every week.",
  },
  {
    id: "morgan-mathiowetz",
    name: "Morgan Mathiowetz",
    school: "North Dakota State University Commit",
    accolade: "#9 Ranked 2027 Class",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/1e8p5m84_IMG_2589.jpg",
    quote: "BeGreat basketball is truly building something special. They offer elite training, genuine support to their athletes, and help you become a better player and person. It has been great working with Isaac and the BeGreat family to prepare me for the next level and learn from some of the best.",
  },
  {
    id: "lucas-gustafson",
    name: "Lucas Gustafson",
    school: "Northwestern (IA)",
    accolade: "College Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/hodb6yzv_IMG_2590.jpg",
    quote: "BeGreat will form you into a complete basketball player. The trainers you work with know everything you need to know and if you mess up they will be there right away to fix the little things. I am beyond blessed to work with BeGreat and it has made me a completely different basketball player.",
  },
  {
    id: "brooklyn-lewis",
    name: "Brooklyn Lewis",
    school: "Minnesota State University",
    accolade: "D2 Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/pl8vbpmf_IMG_2591.jpg",
    quote: "Since starting to train with BeGreat, I have seen huge gains in my consistency and skill set. Training sessions are always intentional and customized for my needs focusing on skills I can put into game action immediately. Beyond the skills, consistent training with BeGreat has given me an incredible edge heading into this season — playing with confidence and the self-assurance to take risks on the court. The trainers have an obvious passion for what they do and bring a ton of energy to every session. If you want to take your game and mentality to the next level, there is no one better than BeGreat!",
  },
  {
    id: "hunter-vinkemeier",
    name: "Hunter Vinkemeier",
    school: "Augustana Commit",
    accolade: "#9 Ranked Player · Minnesota",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ij44qzs3_IMG_2592.jpg",
    quote: "BeGreat basketball is truly an amazing program — from individual training to the tournaments they set up. You get to train and play against some of the best players around the area. Right when I first got there the coaches were friendly and personable. I personally have grown in footwork and finishing. BegrEAT is a great place to train if you want to have a good time or go play at the next level.",
  },
  {
    id: "cole-jacobson",
    name: "Cole Jacobson",
    school: "Northwestern (IA)",
    accolade: "Area Player of the Year",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/mszewn3j_IMG_2593.jpg",
    quote: "BeGreat training has turned me into a completely different player. There are so many different complex drills that have prepared me for in-game situations. So glad I'm fortunate enough to have the opportunity to work out with the most elite guys in the area.",
  },
  {
    id: "amari-nobles",
    name: "Amari Nobles",
    school: "Augsburg",
    accolade: "#23 Ranked · 2026 Class",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/8q5vzxah_IMG_2594.jpg",
    quote: "BeGreat training offers elite training with a competitive aspect while also being really supportive. Isaac has helped me so much with recognizing the game easier — while still helping me with my finishing around the rim. It has been amazing working with BeGreat and Isaac helping me reach my full potential.",
  },
  {
    id: "macy-birkholz",
    name: "Macy Birkholz",
    school: "Wayne State",
    accolade: "D2 Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ut3w9kwx_IMG_2595.jpg",
    quote: "BeGreat basketball offers personalized, game-like training that challenges and expands your playmaking, finishing, and shooting abilities — which grants you the confidence to apply them directly to game play. BeGreat's knowledgeable and experienced trainers create a positive and supportive environment that pushes you to become a more skillful and poised player! I'm grateful to be a part of this exceptional training program and would recommend BeGreat to all who are serious about taking their game to the next level!",
  },
  {
    id: "carson-johnson",
    name: "Carson Johnson",
    school: "University of Denver",
    accolade: "D1 · Summit League Player of the Year",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/fx0ec052_IMG_2596.jpg",
    quote: "I first started working with JT during my freshman season at MSUM. I was redshirting that year and was able to work out with him every day. With all of his workouts, I felt my skill set expanding and I had a better understanding of what it took to be a college point guard. The training transitioned so much to the game that when I had my redshirt pulled mid-season, I was ready to go. All of this hard work allowed me to not only adapt to the college level, but have a very successful season. I learned so much from JT, and the constant time in the gym together led me to transferring to the Division I level and having a Player of the Year season in the Summit League. None of this is possible without the tools that I gained from JT during my freshman year.",
  },
  {
    id: "brylee-miller",
    name: "Brylee Miller",
    school: "Minnesota State University",
    accolade: "D2 Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/5ngry396_IMG_2597.jpg",
    quote: "BeGreat has made such an impact on my game. The fast tempo workouts and having a high-energy trainer gets me prepared for the speed of the game. Not only do I improve my skills physically but my basketball IQ has improved greatly — and I am always looking forward to my next workout!",
  },
  {
    id: "eesher-sigh-sarai",
    name: "Eesher Sigh Sarai",
    school: "Winthrop University",
    accolade: "NCAA D1 Signee · First Canadian Turbaned Sikh to Play D1",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/ps0e3tm3_IMG_2598.jpg",
    quote: "I started working out with Coach Joich the first day I got to Ellsworth CC for my sophomore year. He already knew what to work on for me right at the beginning and had a great evaluation for my game. He completely transformed my ability to use my body on drives and in the post — something I struggled with quite a bit. I could feel the growth in my game every single day. This constant work helped me jump from 4 PPG as a freshman to an efficient 11 PPG sophomore year that led to me being an All-Region, All-Defensive, and All-NJCAA All-Tournament Team player — huge in helping me sign NCAA D1 to Winthrop University, becoming the first Canadian turbaned Sikh to play D1. Any kid in my position would be extremely lucky to have a year of growth and development with Joich.",
  },
  {
    id: "jacey-swanson",
    name: "Jacey Swanson",
    school: "Dakota Wesleyan",
    accolade: "College Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/mwxjk0on_IMG_2599.jpg",
    quote: "Training with Isaac and the BeGreat community has opened a gateway of opportunities for my game to expand. BegrEAT provides game-like situations and high basketball IQ. Isaac teaches at a high energy, is supportive of every athlete, and has a consistent environment which has helped me become a better person and player. I am grateful to have a family that helps me BeGreat!",
  },
  {
    id: "journey-swanson",
    name: "Journey Swanson",
    school: "Dakota Wesleyan",
    accolade: "College Athlete",
    image: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/2u4iqfln_IMG_2600.jpg",
    quote: "Training with BeGreat has helped develop and expand my game in various ways. The workouts are game-like and intentionally put together to help athletes become better players with each session. The high energy and support felt at each workout keeps me excited and motivated for the next one. BeGreat training is an amazing way to help take your game to the next level!",
  },
];

// =========================================================================
// COACHES & PARENTS — text-only testimonials
// =========================================================================
export const COACHES_PARENTS = [
  {
    id: "judd-walter",
    name: "Judd Walter",
    role: "SE-St Mary's Boys Head Coach",
    quote: "BeGreat Basketball has been an absolute game-changer for my sons. The level of training they provide is truly elite — a perfect combination of technical skill development, basketball IQ, and personal growth. Each session is well-structured, high energy, and tailored to push young athletes to their full potential. The trainers are not only incredibly knowledgeable but also genuinely invested in the success of each player.",
  },
  {
    id: "jake-schrom",
    name: "Jake Schrom",
    role: "Parent",
    quote: "We can't say enough good things about BeGreat Basketball. Our boys train with Isaac, and he does an incredible job working with all skill levels. They genuinely look forward to every session and have improved so much through his training.",
  },
  {
    id: "heather-anderson",
    name: "Heather Anderson",
    role: "All-American at MSU · Parent",
    quote: "Malik has been an incredible basketball trainer for my 9-year-old daughter. From the very first session, he created a positive and engaging environment that made her feel confident and excited to learn. He has a great way of connecting with young athletes — balancing fun with focused skill development. I can't say enough positive things about Karson and Isaac and the incredible impact they've had on my 11-year-old son. They've not only helped him tremendously with his basketball skill development, but more importantly, they've been true mentors to him — on and off the court.",
  },
  {
    id: "mitch-lewis",
    name: "Mitch Lewis",
    role: "New Ulm Public Girls Head Coach",
    quote: "High-level training can be a grind, but with Isaac and the other trainers at BeGreat there has always been the anticipation of 'when is my next workout.' I have noticed not only skill development and decision-making improvements but the added confidence both Brooklyn and Rex are playing with is a testament to what is really happening at these workouts.",
  },
  {
    id: "renae-danberry",
    name: "Renae Danberry",
    role: "Parent",
    quote: "We've seen a remarkable difference in our boys since joining BeGreat training. As parents, it's been incredibly rewarding to watch their growth — not just in their skills, but in their confidence and overall mindset. The program's focus on proper fundamentals, consistency, and intentional development has truly elevated their game. Isaac and his team create an environment that is encouraging, basketball-driven, and focused while still keeping it fun. Through consistent, high-quality training, our boys have developed a stronger basketball IQ, greater discipline, and a deeper understanding of the game they love so much.",
  },
  {
    id: "jerhod-smithback",
    name: "Jerhod Smithback",
    role: "Parent",
    quote: "BeGreat is a game-changer for basketball and life! We have seen an incredible transformation in our two sons on and off the court as they worked with Isaac and Karson for the past year. Our sons have significantly increased their self-confidence and skill sets, fueling their desire to outwork the competition. The BeGreat focus on skill-work progression applied to in-game situational reads unlocks next-level results. The hours of driveway basketball at home have become extensions of lessons in footwork, pace, handling, and scoring. Isaac and Karson bring passion and energy creating a positive environment for student-athletes to succeed. We are so grateful our children have them as role models.",
  },
  {
    id: "ryan-hulke",
    name: "Ryan Hulke",
    role: "Minnesota Rise Girls Director",
    quote: "Isaac excels at building rapport with players through his high energy and basketball knowledge. He effectively delivers age-appropriate instruction on in-game skills — specifically, his focus on change of pace and small-sided games translates to live competition on the basketball court.",
  },
  {
    id: "christy-bode",
    name: "Christy Bode",
    role: "Parent",
    quote: "Since January 2025, my three sons (ages 10, 13, and 16 at the time we started) have trained consistently with Isaac, and the growth we've seen — in skill, effort, and especially confidence — has been remarkable. He has an incredible gift for connecting with young athletes and bringing out their best, both on and off the court. Isaac is more than a trainer; he's a mentor and a difference-maker in my boys' lives.",
  },
  {
    id: "sara-gostonczik",
    name: "Sara Gostonczik",
    role: "Parent",
    quote: "BeGreat Basketball Training consistently delivers an elite experience that exceeds all expectations. Isaac brings incredible energy to every session and has a unique ability to connect with every athlete. We've seen a significant transformation in our kids' skills — particularly in their dribbling, footwork, and finishes — which is a direct reflection of his technical knowledge and detailed training approach. Beyond the physical gains, the confidence he builds is what truly sets him apart; our kids leave every session believing in themselves more and more. If you want a high-energy, superior-quality environment that gets results, this is it! A+++",
  },
  {
    id: "nikki-allen",
    name: "Nikki Allen",
    role: "Parent",
    quote: "Since my 11-year-old son started training with BeGreat basketball trainer Joich Gong, his confidence has grown tremendously. Joich has done an amazing job fine-tuning his ball-handling skills and strengthening his left hand. He constantly challenges him to push himself harder and always give 100%. What stands out most is the high standard Joich holds his athletes to while also developing the mindset of consistency, discipline, and hard work. He is calm, supportive, and encouraging, but also knows how to challenge players to reach their full potential. We've seen so much growth in both skill and confidence, and we are incredibly grateful for the impact he has had on our son's development both on and off the court.",
  },
];

// =========================================================================
// SCHOOL CAMPS
// =========================================================================
export const SCHOOL_CAMPS = {
  poster: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/60r85wyt_IMG_2582.jpg",
  gallery: [
    { id: "p1", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/yn8oo7dq_IMG_2585.jpg" },
    { id: "p2", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/00a4d6ji_IMG_2584.jpg" },
    { id: "p3", src: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/kaq3tme0_IMG_2583.jpg" },
  ],
  intro: "BeGreat travels to schools and youth programs across Minnesota to deliver high-energy, skill-focused camps. Boys and girls, all grade levels — every session is built around the BeGreat philosophy: game skills equal game results.",
  limitedSpots: "Don't miss your chance! Spots for Summer 2026 are filling up quickly. Ensure your school is part of this transformative experience by contacting us today.",
  whatYouGet: [
    "High-energy skill-focused instruction from BeGreat coaches",
    "Position-flexible drills built around game-speed decisions",
    "Small-group breakouts for individualized coaching",
    "Footwork, ball-handling, shooting, finishing & live-play breakdowns",
    "Optional video recap from our content team",
  ],
  schedule: [
    { id: "c1", dates: "June 1 & 2", school: "GFW", month: "June" },
    { id: "c2", dates: "June 8 & 9", school: "Wabasso", month: "June" },
    { id: "c3", dates: "June 15 & 17", school: "Blue Earth Area", month: "June" },
    { id: "c4", dates: "June 22 & 23", school: "NUBBA · New Ulm", month: "June" },
    { id: "c5", dates: "June 29 & 30", school: "Redwood", month: "June" },
    { id: "c5b", dates: "July 9 & 10", school: "JWP", month: "July" },
    { id: "c6", dates: "July 13 & 14", school: "Lake Crystal", month: "July" },
    { id: "c7", dates: "July 15 & 16", school: "Windom", month: "July" },
    { id: "c8", dates: "July 20 & 21", school: "Springfield", month: "July" },
    { id: "c9", dates: "July 27 & 28", school: "MCC", month: "July" },
    { id: "c11", dates: "August 5 & 6", school: "Mountain Lake", month: "August" },
    { id: "c12", dates: "June 4, 18, 25 · July 23, 30", school: "MVL · Weekly Series", month: "Summer" },
  ],
};

// =========================================================================
// SHANE HENNEN CAMP
// =========================================================================
export const SHANE_CAMP = {
  title: "BeGreat × Shane Hennen Summer Skills Camp",
  poster: "https://customer-assets.emergentagent.com/job_hoops-luxe/artifacts/y6h5hv1o_IMG_2586.jpg",
  partnerHandle: "@hennen_workouts",
  hostHandle: "@begreatbasketballtraining",
  dates: "August 3–4",
  location: {
    name: "Minnesota Valley Lutheran High School",
    address: "45638 561st Ave, New Ulm, MN 56073",
    mapsUrl: "https://maps.google.com/?q=45638+561st+Ave,+New+Ulm,+MN+56073",
  },
  description:
    "BeGreat Basketball Training is partnering with world-renowned basketball trainer Shane Hennen to deliver an elite 2-day skills camp. Shane Hennen (Minneota graduate) and Isaac Fink (Springfield graduate) serve as the lead instructors — together they've developed players at every level, from youth athletes to professionals. Campers can expect a high-energy, fast-paced environment designed to challenge players, sharpen fundamentals, expand skill development, and deepen their overall understanding of the game.",
  notes: [
    "2 days of camp: August 3 and August 4",
    "Times are the same both days · 2 hours each day · 4 hours of total skill work",
    "Boys and girls in the same sessions; split for any live play",
    "Bring your own basketball",
    "Grade groupings are for the 2026/2027 school year",
    "A videographer will be filming the camp for a recap video",
  ],
  sessions: [
    {
      id: "ses1",
      time: "9:00 AM – 11:00 AM",
      grades: "3rd – 5th Grade",
      who: "Boys & Girls",
      regUrl: "https://buy.stripe.com/28EaEY1i8dxx92z5iZ3F603",
      spotsLabel: "Limited spots left",
    },
    {
      id: "ses2",
      time: "12:00 PM – 2:00 PM",
      grades: "6th – 8th Grade",
      who: "Boys & Girls",
      regUrl: "https://buy.stripe.com/7sY28sd0Q8dd4Mj4eV3F608",
      soldOut: true,
    },
    {
      id: "ses3",
      time: "3:00 PM – 5:00 PM",
      grades: "9th – 12th Grade",
      who: "Boys & Girls",
      regUrl: "https://buy.stripe.com/fZueVe0e4ctt2Eb9zf3F609",
      spotsLabel: "Limited spots left",
    },
  ],
};


// =========================================================================
// FALL LEAGUE — 5-on-5 Boys Fall League at Bethany Lutheran College
// =========================================================================
export const FALL_LEAGUE = {
  title: "BeGreat 5-on-5 Boys Fall League",
  dates: "October 11 & 18",
  poster: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/4rc0xla8_image.png",
  location: {
    name: "Bethany Lutheran College",
    address: "700 Luther Dr, Mankato, MN 56001",
    mapsUrl: "https://maps.google.com/?q=Bethany+Lutheran+College+Mankato+MN",
  },
  description:
    "The BeGreat 5-on-5 Fall League is designed to give players the opportunity to develop their skills, compete, and play meaningful live basketball before the winter season begins. Each day begins with 30 minutes of skill development led by the BeGreat Basketball Training team, followed by two 40-minute 5-on-5 games. Players will compete in 4 total games over the two league dates. Our goal is to create a competitive environment where players can apply the skills, reads, decision-making, and concepts we work on during training directly into live game situations.",
  notes: [
    "2 league dates: October 11 & October 18",
    "30 minutes of skill work led by the BeGreat team, then two 40-minute 5-on-5 games each day",
    "4 total games over the two league dates",
    "Teams capped at 9 players to maximize playing time",
    "Each team will have its own coach throughout the league",
    "Every registered player receives a BeGreat Basketball Training T-shirt",
  ],
  refundPolicy:
    "Because T-shirt orders are submitted based on each registration, all registrations are non-refundable. Refunds will only be considered in the case of an injury that prevents the player from participating.",
  sessions: [
    {
      id: "fl-jv",
      time: "1:00 PM – 4:00 PM",
      grades: "Grades 7–9",
      who: "JV League · Boys",
      regUrl: "https://buy.stripe.com/00w6oI8KAdxx6Ur7r73F60b",
      soldOut: true,
    },
    {
      id: "fl-varsity",
      time: "5:00 PM – 8:00 PM",
      grades: "Grades 10–12",
      who: "Varsity League · Boys",
      regUrl: "https://buy.stripe.com/bJeeVe5yobppdiPbHn3F60a",
      soldOut: true,
    },
  ],
};

// =========================================================================
// GIRLS CAMP — All Girls Camp led by Isaac Fink + 3 Former D1 players
// =========================================================================
export const GIRLS_CAMP = {
  title: "BeGreat All Girls Camp",
  date: "Sunday, October 4",
  poster: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hoops-luxe/artifacts/jpg5j37a_image.png",
  location: {
    name: "Bethany Lutheran College",
    address: "700 Luther Dr, Mankato, MN 56001",
    mapsUrl: "https://maps.google.com/?q=Bethany+Lutheran+College+Mankato+MN",
  },
  leadHeadline: "Led by Isaac Fink + 3 Former D1 Players",
  description:
    "Join BeGreat Basketball Training for our All Girls Camp on Sunday, October 4th at Bethany Lutheran College in Mankato, MN. This camp is led by BeGreat Director Isaac Fink alongside three former Division I women's basketball players. Both gyms at Bethany will be utilized, allowing players to split into groups and work through different skill and game-play themes with our staff.",
  coaches: [
    { name: "Isaac Fink", school: "BeGreat Director", accolade: "" },
    { name: "Maddie Mathiowetz", school: "SDSU", accolade: "All-Summit League" },
    { name: "Mesa Byom", school: "SDSU", accolade: "Summit League Defensive Team" },
    { name: "Molly Lenz", school: "NDSU", accolade: "Summit League All-Newcomer Team" },
  ],
  notes: [
    "Two age groups · Both gyms at Bethany utilized",
    "Players split into groups to work skill and game-play themes with staff",
    "Grades 7–12 includes a recruiting talk with advice from our staff's college basketball experience",
    "Players must bring their own basketball",
    "BeGreat T-shirt included for every registered player",
  ],
  sessions: [
    {
      id: "gc-36",
      time: "10:00 AM – 1:00 PM",
      grades: "Grades 3–6",
      who: "Fundamentals · All Girls",
      focus: ["Finishing", "Shooting", "Ball Handling", "Decision Making"],
      focusHeading: "Fundamental BeGreat concepts",
      regUrl: "https://buy.stripe.com/6oUaEYaSIalldiPbHn3F60c",
      soldOut: true,
    },
    {
      id: "gc-712",
      time: "2:00 PM – 5:00 PM",
      grades: "Grades 7–12",
      who: "Advanced · All Girls",
      focus: ["Advanced Skill Development", "Finishing & Shot Creation", "Live Small-Sided Games", "Recruiting Talk & Advice"],
      focusHeading: "Advanced session",
      regUrl: "https://buy.stripe.com/14A8wQe4U0KL92z8vb3F60d",
      soldOut: true,
    },
  ],
};

